




















































/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */
import RouteAssistant from '@/helpers/route-assistant'
import ColorAssistant from '@/helpers/color-assistant'

/* Data types */
import { IChecklist, IChecklistTemplate } from '@/api/types/response.types'

/* API */
import InternalProjectsAPI from '@/api/modules/internal-projects.api'
import MailboxesAPI from '@/api/modules/mailboxes.api'

export default Vue.extend({
  name: 'LinkSavedChecklistPanel',

  props: {
    existingChecklists: {
      type: Array as () => IChecklist[],
      default: (): IChecklist[] => [],
    },
    checklistTemplates: {
      type: Array as () => IChecklistTemplate[],
      default: (): IChecklistTemplate[] => [],
    },
    isLinkedToTask: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      RouteAssistant,
      ColorAssistant,
    }
  },

  computed: {
    projectID(): number {
      return Number(this.$route.params.id)
    },
    itemID(): number {
      return Number(this.$route.params.childId)
    },
  },

  methods: {
    routeToChecklistTemplateSettings() {
      if (this.isLinkedToTask) {
        this.$router.push(
          RouteAssistant.getProjectSettingsChecklistTemplateRoute(
            this.$route.params.accountId,
            this.projectID,
          ),
        )
      } else {
        this.$router.push(
          RouteAssistant.getMailboxSettingsChecklistTemplateRoute(
            this.$route.params.accountId,
            this.projectID,
          ),
        )
      }
    },
    async addChecklistTemplate(checklistTemplateID: number) {
      if (this.isLinkedToTask) {
        const checklist = await InternalProjectsAPI.post_ChecklistTemplateAddToTask(
          this.projectID,
          checklistTemplateID,
          this.itemID,
        )
        this.$emit('checklist-created', checklist)
      } else {
        const checklist = await MailboxesAPI.post_ChecklistTemplateAddToConvo(
          this.projectID,
          checklistTemplateID,
          this.itemID,
        )
        this.$emit('checklist-created', checklist)
      }

      this.$emit('canceled')
    },
  },
})
